import TopPanel from './components/TopPanel';
import SlidingPanel from './components/SlidingPanel';
import HeroSection from './components/HeroSection';
import HeroText from './components/HeroText';
import CardsBlock from './components/CardsBlock';
import InfoBlock from './components/InfoBlock';
import Brands from './components/Brands';
import ScrollablePanel from './components/ScrollablePanel';
import TestimonialsCarousel from './components/TestimonialsCarousel';
import FaqBlock from './components/FaqBlock';
import GetInTouchForm from './components/GetInTouchForm';
import Footer from './components/Footer';
import './styles.css';
import './LandingPage.css';

const LandingPage = () => {
  return (
    <div className="redesign-landing">
      <HeroSection>
            <div className="landing-header-wrapper">
              <TopPanel />
              <SlidingPanel />
            </div>
            <HeroText />
        </HeroSection>
      <div className="content-container">
        <CardsBlock />
        <InfoBlock />
        <Brands />
        <ScrollablePanel />
        <TestimonialsCarousel />
        <FaqBlock />
        <GetInTouchForm />
        <Footer />
      </div>
    </div>
  );
};

export default LandingPage;
